import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";
import { closeModal } from "./modalActions";
import EditSystemUserForm from "../auth/Register/EditSytemUserForm"; // fixed typo in name

const actions = { closeModal };

const EditSystemUserModal = ({ closeModal, modalProps }) => {
  const { user } = modalProps;
 
  return (
    <Modal modalHeader="Edit PrepaidPlus User" onClose={closeModal}>
      <EditSystemUserForm user={user} />
    </Modal>
  );
};

export default connect(
  (state) => ({
    modalProps: state.modals.modalProps,
  }),
  actions
)(EditSystemUserModal);
